import FavoriteStandGrid from "./favorite-stand-grid";

export default FavoriteStandGrid;